import DeleteAllAction from './delete-all-action.vue';

const actions = [
	DeleteAllAction,
];

export default actions;
